const getAddress = (address)=>{
    if (!address) {
        return undefined;
    }
    const { apartment , city , countryCode , salutation , firstName , lastName , streetName , streetNumber , additionalStreetInfo , postalCode , region , externalId , company ,  } = address;
    return {
        city,
        countryCode,
        firstName,
        lastName,
        streetName,
        salutation: salutation !== null && salutation !== void 0 ? salutation : '',
        streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : '',
        apartment: apartment !== null && apartment !== void 0 ? apartment : '',
        postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : '',
        additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : '',
        region: region !== null && region !== void 0 ? region : '',
        externalId: externalId !== null && externalId !== void 0 ? externalId : '',
        company: company !== null && company !== void 0 ? company : ''
    };
};

export { getAddress };
//# sourceMappingURL=get-address.js.map
